module.exports = __webpack_public_path__ + "images/emoji/anguished.9151f068093666ac502b.png";